export default __webpack_public_path__ + "static/media/project6.31dbc6a2.png";